import React from "react";
import { Typography, Layout, Divider, Button, Col } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div>
              <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/")}
          style={{
            top: "24px",
            marginLeft:"180px",
            fontSize: "16px",
            fontWeight: "500"
          }}
        >
          Back
        </Button>
        <Content
      style={{
        margin: "0 auto",
        padding: "40px 24px",
        maxWidth: "900px",
        fontFamily: "Inter, sans-serif",
        borderRadius: "12px",
        overflowY:"auto"
      }}
    >

        <Typography>
          <Title style={{ fontSize: "36px", fontWeight: 700 }} level={2}>
            Privacy Policy
          </Title>
          {/* <Paragraph style={{ fontSize: "16px" }}>
            Last updated: April 29, 2025
          </Paragraph> */}

          <Divider />

          <Paragraph style={{ fontSize: "16px" }}>
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </Paragraph>

          <Paragraph style={{ fontSize: "16px" }}>
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of information
            in accordance with this Privacy Policy.
          </Paragraph>

          <Divider />

          <Title level={4}>Interpretation and Definitions</Title>
          <Paragraph>
            The capitalized words have specific meanings defined in this section.
            The definitions apply regardless of singular or plural usage.
          </Paragraph>

          <Title level={5}>Definitions</Title>
          <Paragraph>
            <ul>
              <li><strong>Account</strong>: A unique profile for accessing our Service.</li>
              <li><strong>Affiliate</strong>: Entities under common control with us.</li>
              <li><strong>Company</strong>: Refers to SmartForum, F-7, Islamabad, Pakistan.</li>
              <li><strong>Cookies</strong>: Small files storing browsing history.</li>
              <li><strong>Country</strong>: Pakistan.</li>
              <li><strong>Device</strong>: Any internet-capable device.</li>
              <li><strong>Personal Data</strong>: Data relating to an identifiable individual.</li>
              <li><strong>Service</strong>: The Website (themedianest.ai).</li>
              <li><strong>Service Provider</strong>: Third parties processing data for the Company.</li>
              <li><strong>Usage Data</strong>: Data collected automatically while using the Service.</li>
              <li><strong>You</strong>: The individual or entity using the Service.</li>
            </ul>
          </Paragraph>

          <Title level={4}>Collecting and Using Your Personal Data</Title>
          <Title level={5}>Types of Data Collected</Title>
          <Paragraph>
            <strong>Personal Data</strong>: May include your email, first and last name, and usage data.
          </Paragraph>

          <Paragraph>
            <strong>Usage Data</strong>: Includes IP address, browser details, visit timestamps,
            pages visited, and diagnostic logs. Also collected through mobile usage.
          </Paragraph>

          <Title level={4}>Tracking Technologies and Cookies</Title>
          <Paragraph>
            We use Cookies, web beacons, and scripts to enhance and analyze our Service.
            You may control cookie preferences via your browser.
          </Paragraph>

          <Paragraph>
            Types of Cookies we use include:
            <ul>
              <li><strong>Essential Cookies</strong>: For functionality and security.</li>
              <li><strong>Notice Acceptance Cookies</strong>: To track cookie consent.</li>
              <li><strong>Functionality Cookies</strong>: To remember user preferences.</li>
            </ul>
          </Paragraph>

          <Title level={4}>Use of Your Personal Data</Title>
          <Paragraph>
            We use your data to manage your account, provide support, communicate,
            fulfill legal obligations, and improve our services. Data may be shared
            with affiliates, partners, or in the case of business transfers.
          </Paragraph>

          <Title level={4}>Retention of Your Personal Data</Title>
          <Paragraph>
            Personal Data is retained only as long as necessary. Usage Data may be
            kept longer for analysis, security, or compliance.
          </Paragraph>

          <Title level={4}>Transfer of Your Personal Data</Title>
          <Paragraph>
            Your data may be transferred to other jurisdictions with different data
            protection laws. We ensure adequate security for such transfers.
          </Paragraph>

          <Title level={4}>Delete Your Personal Data</Title>
          <Paragraph>
            You may delete your data via account settings or by contacting us at
            <a href="mailto:info@smartforum.org"> info@smartforum.org</a>. Legal
            retention obligations may apply.
          </Paragraph>

          <Title level={4}>Disclosure of Your Personal Data</Title>
          <Paragraph>
            Your data may be disclosed during legal processes, business
            transactions, or to protect the safety and rights of the Company or
            public.
          </Paragraph>

          <Title level={4}>Security of Your Personal Data</Title>
          <Paragraph>
            We implement reasonable security measures but cannot guarantee absolute
            security.
          </Paragraph>

          <Title level={4}>Children's Privacy</Title>
          <Paragraph>
            We do not knowingly collect data from children under 13. If you are a
            parent or guardian aware of such collection, please contact us.
          </Paragraph>

          <Title level={4}>Links to Other Websites</Title>
          <Paragraph>
            We are not responsible for the privacy practices of external sites
            linked from our Service. Please review their policies separately.
          </Paragraph>

          <Title level={4}>Changes to this Privacy Policy</Title>
          <Paragraph>
            We may update this policy periodically. Changes will be posted on this
            page, and users may be notified via email or prominent notices.
          </Paragraph>

          <Title level={4}>Contact Us</Title>
          <Paragraph>
            If you have questions about this policy, contact us at
            <a href="mailto:info@smartforum.org"> info@smartforum.org</a>.
          </Paragraph>
        </Typography>
      </Content>
    </div>

  );
};

export default PrivacyPolicy;